import { ListDataSyncExcelRowsResponseSchema } from './list-data-sync-excel-rows.schema';
export const listDataSyncExcelRowsContract = {
    method: 'GET',
    path: '/api/v2/data-sync/excel-rows',
    description: 'List the sheets of the Excel download, with the Bliks id column',
    responseSchema: ListDataSyncExcelRowsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not allowed to manage the data source'
        }
    }
};

//# sourceMappingURL=list-data-sync-excel-rows.contract.js.map